// extracted by mini-css-extract-plugin
export default {"feature_dashboard_home":"home_feature_dashboard_home__bHLLm"};